/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import React from "react";
import Slider from "react-slick";

import {WealthyEnv} from "helpers";

import styled from "styled-components";
import advisors from "./advisors";
import Overlay from "./component/Overlay";

const CDN_URL = WealthyEnv.HOMEPAGE_CDN_URL;

const leftArrow = `${CDN_URL}/partners-advisors-carousel-left-arrow.svg`;
const rightArrow = `${CDN_URL}/partners-advisors-carousel-right-arrow.svg`;
const shareIcon = `${CDN_URL}/partners-advisors-carousel-share-icon.svg`;

const OurAdvisors = ({
  settings,
  setShowOverlay,
  setActiveVideo,
  activeVideo,
  showOverlay
}) => {
  const content = advisors.map((advisor) => {
    return (
      <AdvisorCard
        className="advisor-card"
        key={advisor.id}
      >
        <AdvisorImage
          onClick={() => {
            setShowOverlay(true);
            setActiveVideo(advisor.videoLink);
          }}
        >
          <img
            alt="active-advisor-image"
            className="card-image"
            loading="lazy"
            src={advisor.image}
            style={{...advisor.imageStyles}}
          />
        </AdvisorImage>
        <AdvisorDetails>
          <p className="advisor-name">{advisor.name}</p>
          <p className="advisor-designation">{advisor.designation},&nbsp;{advisor.experience}</p>
        </AdvisorDetails>
      </AdvisorCard>
    );
  });

  return (
    <>
      <Wrapper id="3reviews">
        <Title>Building Wealth for everyone, one partner at a time</Title>
        <Description>
          From Dwarka to Darjeeling, and Chandigarh to Chennai,
          join our community of entrepreneurs building wealth for clients and business for themselves.
        </Description>
        <AdvisorSliderContainer>
          <Slider {...settings}>
            {content}
          </Slider>
        </AdvisorSliderContainer>
        <Button href="#share">
          Share this with a friend
          <img alt="right-arrow-icon" className="share-icon" loading="lazy" src={shareIcon} />
        </Button>
      </Wrapper>
      {
        showOverlay &&
          <Overlay
            setShowOverlay={setShowOverlay}
            videoLink={activeVideo}
          />
      }
    </>
  );
};

const AdvisorSliderContainer = styled.div`
  width: 90%;
  margin: 0 auto;
  position: relative;

  .slick-prev, .slick-next {
    position: absolute !important;
    top: 35% !important;
  }

  .slick-prev:before {
    content: url(${leftArrow});;
    position: absolute;
    left: 0;
  }

  .slick-next:before {
    content: url(${rightArrow});;
    position: absolute;
    right: 0;
  }

  @media (max-width: 768px) {
    .slick-prev:before, .slick-next:before {
      display: none;
    }
  }
`;

const Button = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 1.2rem;
  background-color: #6725f4;
  text-align: center;
  margin: 6rem auto 0;
  width: 34rem;
  height: 5.6rem;
  font-family: MavenPro;
  font-size: 1.8rem;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.22;
  letter-spacing: normal;
  color: #f9f9f9;
  border: none;

  .share-icon {
    margin-left: 2rem;
  }

  :hover {
    cursor: pointer;
    transition: all 0.3s linear;
    transform: scale(1.03);
  }

`;

const AdvisorCard = styled.div`
  border-radius: unset;
  box-shadow: unset;
  padding: 0;
  margin: 0 auto;
  max-width: 100rem;
  text-align: center;
  display: flex !important;
  flex-direction: column !important;

  .card-image {
    height: 100%;
    width: 100%;
    border-radius: 3rem;
    object-fit: cover;
    object-position: top center;
    opacity: 0.8;
    border-radius: 24px;
    background-color: #1c1c1c;
  }
  .advisor-name {
    margin: 4rem 0 1.2rem 0;
    font-family: MavenPro;
    font-size: 1.8rem;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #fff;
  }

  .advisor-designation {
    font-family: MavenPro;
    font-size: 2.4rem;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #fff;
    margin-bottom: 4rem;
  }


  @media (max-width: 768px) {
    height: auto;
    flex: 1 0 70%;
    &::before {
      border-radius: 2rem;
    }
    .card-image {
      border-radius: 2rem;
    }
    .advisor-name {
      font-size: 1.8rem;
    }
    .advisor-designation {
      font-size: 1.8rem;
    }
  }
`;

const AdvisorImage = styled.div`
  position: relative;
  width: 100%;
  margin: 0 auto;
  display: flex;

  border-radius: 3rem;
  cursor: pointer;
  transition: transform 300ms linear;

  &:hover {
    transform: scale(1.02);
  }
`;

const AdvisorDetails = styled.div`
  margin: 0 auto;
  width: 90%;
`;

const Wrapper = styled.div`
  padding: 10rem 0;
  background-color: #1c1c1c;

  .slick-dots li button:before {
    color: #f9f9f9;
  }

  @media (max-width: 768px) {
    padding: 10rem 2rem;
  }
`;

const Title = styled.h3`
  font-family: MavenPro;
  font-size: 3.6rem;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.48;
  letter-spacing: normal;
  text-align: center;
  color: #f9f9f9;
  margin-bottom: 2.4rem;

  @media (max-width: 768px) {
    font-size: 2.4rem;
    width: 100%;
  }
`;

const Description = styled(Title)`
  font-size: 1.8rem;
  font-weight: normal;
  line-height: 1.67;
  width: 60%;
  margin: 0 auto 7rem;
  color: #7e7e7e;

  @media (max-width: 768px) {
    font-size: 1.8rem;
    width: 100%;
  }
`;

export default OurAdvisors;
